import './css/map.css';

import React from 'react'
import mapboxgl from 'mapbox-gl'
import { withRouter } from "react-router-dom";
import { ISLAND_CENTER } from "./config";

mapboxgl.accessToken = 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA';

export class Map extends React.Component {

	constructor(props: Props) {
		super(props);

		this.state = {
			lng: ISLAND_CENTER.longitude,
			lat: ISLAND_CENTER.latitude,
			zoom: 9
		};
		this.markers = []
	}

	componentDidMount(props) {

		console.log("mount");

		const { lng, lat, zoom } = this.state;

		this.map = new mapboxgl.Map({
			container: this.mapContainer,
			style: 'mapbox://styles/mapbox/streets-v9?optimize=true',
			center: [lng, lat],
			zoom
		});

		this.renderMap();

	}

	componentDidUpdate() {

		this.renderMap();

	}


	renderMap() {

		const props = this.props;
		const { lng, lat, zoom } = this.state;


		if (this.mapContainer && props && props.state && props.state.data) {


			if (!this.markers.length) {
				this.initMarkers(props);
			}

			this.renderMarkers(props);



		}
	}


	componentWillReceiveProps(nextProps) {
		if (!nextProps.state.data) return;
	}

	initMarkers(props) {

		var popup = new mapboxgl.Popup({ offset: 25 });

		props.state.data.forEach(point => {

			if (point.coords) {

				var el = document.createElement('div');
				el.className = 'marker '
				el.style.background = point.color;

				var el2 = document.createElement('i');
				el2.className = 'icon ' + point.icon.replace("fa-", "").replace("-", " ")
				el.appendChild(el2);


				let marker = new mapboxgl.Marker(el);
				let coords = [point.coords.lng, point.coords.lat];

				marker
					.setLngLat(coords)
					.addTo(this.map);

				marker.data = point;
				this.markers.push(marker);


				el.addEventListener('click', () => {
					this.props.history.push(marker.data.path);
				});

				el.addEventListener('mouseover', () => {
					el.style.border = "1px solid #ddd";

					popup.setLngLat(coords)
						.setHTML(point.name)
						.addTo(this.map);
				})

				el.addEventListener('mouseout', () => {
					el.style.border = "";
					popup.remove();
				});


			}
		});

	}


	renderMarkers() {

		let props = this.props;
		let cat = props.state.currentCategory;
		let typ = props.state.currentTypology;
		let currentPath = props.match ? props.match.params.path : null;
		let selectedItem;


		this.markers.forEach(d => {

			let el = d.getElement();
			let b = true;

			if (cat) {
				b = cat == d.data.category;
				if (typ) {
					b = typ == d.data.typology.name;
				}
			}

			el.style.visibility = b ? "visible" : "hidden";

			if (currentPath) {
				el.style.opacity = currentPath == d.data.path ? 1 : .5;
				if (currentPath == d.data.path) {
					selectedItem = d;
				}
			} else {
				el.style.opacity = 1;
			}


		});

		if (selectedItem) {
			let currentzoom = this.map.getZoom();
			this.map.easeTo({
				center: selectedItem.getLngLat(),
				duration: 1000,
				zoom: currentzoom < 12 ? 12 : currentzoom
			});
		} else {
			this.map.easeTo({
				center: [-15.5, 28.004708],
				duration: 1000,
				zoom: 9,
			});
		}

	}

	render() {


		return (
			<div id="map" style={this.props.style}>
				<div ref={el => this.mapContainer = el} style={{ position: "absolute", bottom: 0, top: 0, width: "100%" }} />
			</div>
		);
	}
}

export default withRouter(Map);



// WEBPACK FOOTER //
// ./src/Map.js